<script setup lang='ts'>
import { inject, ref } from 'vue'
import { DEFAULT_CONFIG, useConfig } from '@/config/useConfig'
import { until, useAsyncState } from '@vueuse/core'
import { SsoConfig } from '@/types/interfaces'

declare global {
  const google: any
}

const loadGoogleClient = inject('loadGoogleClient') as () => Promise<boolean>
const handleGoogleLogin = (response: any) => {
  emit('googleLogin', {
    googleToken: response.credential
  })
}

const renderGoogleButton = (config: SsoConfig) => {
  const clientId = config.api?.google_client_id
  if (!clientId) return

  loadGoogleClient().then(() => {
    google.accounts.id.initialize({
      client_id: clientId,
      callback: handleGoogleLogin
    })

    google.accounts.id.renderButton(
      document.getElementById('buttonDiv'),
      { theme: 'outline', width: '400' }
    )
  })
}

const { state, isReady } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
);
(async () => {
  await until(isReady).toBe(true)
  renderGoogleButton(state.value)
})()

const googleClientId = ref(state.value.api?.google_client_id)
const hideButton = ref(googleClientId.value === undefined)

const emit = defineEmits(['googleLogin'])

</script>
<template>
  <div v-if='!hideButton' id='buttonDiv'></div>
</template>
<style>
/* Remove on deploy  */
.google-button {
  background: #fff;
  text-align: center;
  color: #1b222c;
  border: 1px solid #d3dae4;
  padding: 8px 2rem;
  border-radius: 4px;
  font-weight: bold;
  background-image: url(@/assets/img/google-logo.png);
  background-repeat: no-repeat;
  background-position: top 5px left 5px;
  margin-top: 10px;
  cursor: pointer;
  width: 100%;
}
</style>
